import { gql } from "@apollo/client";

export const CREATE_ONLINE_BOOK = gql`
  mutation CreateOnlineBook($input: OnlineBookInput) {
    createOnlineBook(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_ONLINE_BOOK_PAGINATION = gql`
  query GetOnlineBookPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $groupFeeId: String
    $type: String
  ) {
    getOnlineBookPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      groupFeeId: $groupFeeId
      type: $type
    ) {
      data {
        _id
        groupFeeId {
          _id
          type
          title
          price
        }
        title
        numbering
        description
        author
        type
        rating
        pages
        image
        showOnMobile
        discountType
        discountAmount
        payStatus
        keywords
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_ONLINE_BOOK_BY_ID = gql`
  query GetOnlineBookById($id: ID!) {
    getOnlineBookById(_id: $id) {
      _id
      groupFeeId {
        _id
        type
        title
        price
        remark
      }
      numbering
      showOnMobile
      description
      author
      type
      rating
      pages
      image
      isBuy
    }
  }
`;

export const UPDATE_ONLINE_BOOK = gql`
  mutation UpdateOnlineBook($id: ID!, $input: OnlineBookInput) {
    updateOnlineBook(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_ONLINE_BOOK = gql`
  mutation DeleteOnlineBook($id: ID!) {
    deleteOnlineBook(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_BOOK_SHOW_ON_MOBILE = gql`
  mutation UpdateBookShowOnMobile($id: ID!, $showOnMobile: Boolean) {
    updateBookShowOnMobile(_id: $id, showOnMobile: $showOnMobile) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
